export const CUSTOMER_STATUS = {
  1: { label: 'Chưa gửi thông báo', bg: '#F1EFE8', color: '#444441', dot: '#888780' },
  2: { label: 'Đã gửi thông báo', bg: '#E6F1FB', color: '#0C447C', dot: '#378ADD' },
  3: { label: 'Chưa tương tác', bg: '#F1EFE8', color: '#444441', dot: '#888780' },
  4: { label: 'Đang đặt lịch', bg: '#FAEEDA', color: '#633806', dot: '#EF9F27' },
  5: { label: 'Đã đăng ký', bg: '#E1F5EE', color: '#04342C', dot: '#0F6E56' },
  6: { label: 'Đã đặt lịch', bg: '#185FA5', color: '#E6F1FB' },
  7: { label: 'Đã nhắc đi khám', bg: '#FAEEDA', color: '#412402', dot: '#BA7517' },
  8: { label: 'Hoàn thành khám', bg: '#FAECE7', color: '#712B13', dot: '#D85A30' },
  // Có KQ tự động (OCR) nhưng bác sĩ chưa xem/duyệt — chèn giữa 8 và bước gửi TB cũ (PO note:
  // "sao ko thấy trạng thái review"). Khớp BcbCampaignCustomerStatus.PendingDoctorReview ở BE.
  // Màu tím lấy ĐÚNG theo $info/$info-light của theme (_variables.bootstrap.scss) thay vì tự
  // chọn 1 sắc tím khác — status map này không map theo Bootstrap variant nhưng vẫn nên bắt
  // nguồn cùng 1 hệ màu với phần còn lại của app, không phải màu tự chế đứng riêng 1 mình.
  9: { label: 'Chờ bác sĩ review', bg: '#EEE5FF', color: '#4A1D8A', dot: '#8950FC' },
  10: { label: 'Đã gửi kết quả', bg: '#185FA5', color: '#E6F1FB' },
  11: { label: 'Đã xem kết quả', bg: '#E1F5EE', color: '#04342C', dot: '#0F6E56' },
};

export const CUSTOMER_STATUS_OPTIONS = Object.entries(CUSTOMER_STATUS).map(([value, cfg]) => ({
  value: Number(value),
  text: cfg.label,
}));

export const CUSTOMER_STATUS_WORKFLOW = Object.fromEntries(
  Object.entries(CUSTOMER_STATUS).filter(([value]) => Number(value) !== 3)
);

export const CUSTOMER_STATUS_WORKFLOW_OPTIONS = Object.entries(CUSTOMER_STATUS_WORKFLOW).map(([value, cfg]) => ({
  value: Number(value),
  text: cfg.label,
}));

export const BCB_NOTIFICATION_METHOD = {
  AUTO: 0,
  ZNS: 1,
  SMS: 2,
  EMAIL: 3,
};

export const CAMPAIGN_STATUS_OPTIONS = [
  { value: 1, text: 'Bản nháp' },
  { value: 2, text: 'Đang hoạt động' },
  { value: 3, text: 'Đã kết thúc' },
  { value: 4, text: 'Đã huỷ' },
];

export const PARTNER_STATUS_OPTIONS = [
  { value: 1, text: 'Hoạt động' },
  { value: 0, text: 'Không hoạt động' },
];

export const BCB_EXAM_RESULT_TYPE = {
  1: 'Xét nghiệm',
  2: 'Chẩn đoán hình ảnh',
  3: 'Thăm dò chức năng',
  4: 'Nội soi và sinh thiết',
  5: 'Kết quả khám sức khỏe',
};

export const BCB_ADHOC_EMAIL_MODE = {
  TEMPLATE: 0,
  CUSTOM: 1,
};

export const BCB_ADHOC_EMAIL_MODE_OPTIONS = [
  { value: 0, text: 'Dùng template có sẵn' },
  { value: 1, text: 'Soạn tuỳ chỉnh' },
];

export const BCB_SEND_TIMING = {
  NOW: 0,
  SCHEDULED: 1,
};

export const BCB_EXAM_RESULT_TYPE_OPTIONS = [
  { value: null, text: '-- Chọn loại hoạt động --', disabled: true },
  { value: 1, text: 'Xét nghiệm' },
  { value: 2, text: 'Chẩn đoán hình ảnh' },
  { value: 3, text: 'Thăm dò chức năng' },
  { value: 4, text: 'Nội soi và sinh thiết' },
  { value: 5, text: 'Kết quả khám sức khỏe' },
];
